import {RxJsonSchema} from 'rxdb';

export const PatientStatsSchema: RxJsonSchema | any = {
    "version": 0,
    "type": "object",
    "title": "Patient Stats",
    "properties": {
        "key": {
            "type": "string",
            "primary": true,
            "final": true
        },
        "value": {
            "type": ["string", "number", "integer", "null", "boolean", "object", "array"]
        },
        "lastChange": {
            "type": "string"
        }
    }
};
